import gql from "graphql-tag";

import FullCurrentUserFragment from "./FullCurrentUserFragment";

export const currentUserQuery = gql`
  query CurrentUserQuery {
    currentUser {
      ...FullCurrentUserFragment
    }
  }
  ${FullCurrentUserFragment}
`;

export const currentUserLearnerUidQuery = gql`
  query CurrentUserLearnerUid($enrollmentUid: String!) {
    currentUser {
      uid
      enrollment(enrollmentUid: $enrollmentUid) {
        uid
        learner {
          uid
        }
      }
    }
  }
`;
